import { observer } from "mobx-react"
import React, { useState, useEffect } from "react"
import ModalStore from "../../Configs/Store/modals"
import CircleIcon from "../Common/CircleIcon"
import CloseButton from "../Common/CloseButton"
import "../../styles/Header/talkToExpertModal.less"
import GenericModal from "../Common/GenericModal"
import TalkToExpertModalJson from "../../Configs/JSON/talkToExpertModal.json"
import TextMultiStyle from "../Common/TextMultiStyle"
import AppStore from "../../Configs/Store/index"
import CommonStore from "../../Configs/Store/common"

const KnowMoreModal = observer(() => {
  const handleclose = () => ModalStore.setKnowMore(false)
  const closeAllBenMobModal = () => {
    CommonStore.setmythBusterModal(false)
  }

  const [isActive, setActive] = useState(false)

  const toggleClass = () => {
    setActive(!isActive)
  }

  return (
    <>
      <div className="common-modal-wrap">
        <div
          style={{ opacity: "1" }}
          className="modal fade"
          id="exampleModalCenter"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div style={{ height: "auto" }} className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="common-modal-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="knowmore-modal-wrap">
                        <p className="mttl">Know more</p>
                        <p className="modal-ttl">Amount is calculated as:</p>
                        <p className="p">
                          Additional savings (adjusted for growth) when you retire minus expenses (adjusted for
                          inflation) at the time of retirement
                        </p>
                        <button className="btn bttn-lg bttn-primary nextButton st" data-dismiss="modal">
                          Ok, got it
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
})

export default KnowMoreModal
